export const setInputValue = (input: EventTarget & (HTMLInputElement | HTMLTextAreaElement), value: string) => {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
  nativeInputValueSetter?.call(input, value);

  input.dispatchEvent(new Event("input", { bubbles: true }));
};
